import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let CopyToClipboardMixin = class CopyToClipboardMixin extends Mixins(AlertMixin) {
    copyToClipboard(copyText) {
        const self = this;
        const input = document.createElement('input');
        input.setAttribute('value', copyText);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        self.successNotification('Copied to Clipboard!');
    }
};
CopyToClipboardMixin = __decorate([
    Component
], CopyToClipboardMixin);
export default CopyToClipboardMixin;
